export type FilterIconProps = React.SVGProps<SVGSVGElement> & {
  color?: string;
};

export function FilterIcon({ color = "currentColor", ...props }: FilterIconProps) {
  return (
    <svg
      {...props}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 10.0149C14.9113 10.0149 15.65 9.27617 15.65 8.3649C15.65 7.45363 14.9113 6.7149 14 6.7149C13.0888 6.7149 12.35 7.45363 12.35 8.3649C12.35 9.27617 13.0888 10.0149 14 10.0149ZM17.15 8.3649C17.15 10.1046 15.7397 11.5149 14 11.5149C12.2604 11.5149 10.85 10.1046 10.85 8.3649C10.85 6.62521 12.2604 5.2149 14 5.2149C15.7397 5.2149 17.15 6.62521 17.15 8.3649ZM10 18.0149C9.08873 18.0149 8.35 17.2762 8.35 16.3649C8.35 15.4536 9.08873 14.7149 10 14.7149C10.9113 14.7149 11.65 15.4536 11.65 16.3649C11.65 17.2762 10.9113 18.0149 10 18.0149ZM6.85 16.3649C6.85 18.1046 8.2603 19.5149 10 19.5149C11.7397 19.5149 13.15 18.1046 13.15 16.3649C13.15 14.6252 11.7397 13.2149 10 13.2149C8.2603 13.2149 6.85 14.6252 6.85 16.3649ZM13.65 16.3318C13.65 15.9176 13.9858 15.5818 14.4 15.5818H20C20.4143 15.5818 20.75 15.9176 20.75 16.3318C20.75 16.746 20.4143 17.0818 20 17.0818H14.4C13.9858 17.0818 13.65 16.746 13.65 16.3318ZM9.6 7.5818C10.0142 7.5818 10.35 7.91758 10.35 8.3318C10.35 8.74601 10.0142 9.0818 9.6 9.0818L4 9.0818C3.58579 9.0818 3.25 8.74601 3.25 8.3318C3.25 7.91758 3.58579 7.5818 4 7.5818L9.6 7.5818ZM3.25002 16.3318C3.25002 15.9176 3.58581 15.5818 4.00002 15.5818H5.60002C6.01424 15.5818 6.35002 15.9176 6.35002 16.3318C6.35002 16.746 6.01424 17.0818 5.60002 17.0818H4.00002C3.58581 17.0818 3.25002 16.746 3.25002 16.3318ZM20 7.5818C20.4142 7.5818 20.75 7.91758 20.75 8.3318C20.75 8.74601 20.4142 9.0818 20 9.0818L18.4 9.0818C17.9858 9.0818 17.65 8.74601 17.65 8.3318C17.65 7.91758 17.9858 7.5818 18.4 7.5818L20 7.5818Z"
        fill={color}
      />
    </svg>
  );
}
